export const controllWrapperStyles = {
  wrapper: {
    margin: '0px !important',
  },
};
